import { Button, DatePicker } from 'antd';
import React from 'react';
import { ExcelIcon } from 'components/common/SVGIcon';
import { exportExcel } from 'api/crud';
import { ExportExcelWrapper } from './styles';

const ExportExcel = () => {
  const { RangePicker } = DatePicker;
  const [dates, setDates] = React.useState();

  const handleClick = () => {
    const query = {
      startTime: dates[0].startOf('day').toISOString(),
      endTime: dates[1].endOf('day').toISOString(),
    };
    exportExcel('transactions', query);
  };

  return (
    <ExportExcelWrapper>
      <RangePicker value={dates} onChange={(value) => setDates(value)} />
      <Button disabled={!dates} icon=<ExcelIcon /> onClick={handleClick} />
    </ExportExcelWrapper>
  );
};

export default ExportExcel;
